import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { RF_PROFILE_GROUP } from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';
import { doubleEncode } from '../../../../Utils/Encode/UrlHelper';
/**
 * list RFProfileGroups.
 * @returns {Promise} - A promise that resolves with the list of RFProfileGroups or rejects with an error.
 * @param props
 */
export const listRFProfileGroup = async ({
  accessToken,
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const data = {
    Filters: filter,
    pageNumber: offset === 0 ? 1 : offset,
    pageSize: limit,
    sort,
  };

  const response = await apiServiceWrapper({
    url: `${RF_PROFILE_GROUP}/Filter`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    rfProfileGroups: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * Create RFProfileGroup.
 * @returns {Promise} - A promise that resolves with the creation of Profile Group or rejects with an error.
 * @param data
 */
export const createRFProfileGroup = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${RF_PROFILE_GROUP}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update RFProfileGroup.
 * @returns {Promise} - A promise that resolves with the update of Profile Group or rejects with an error.
 * @param data
 */
export const updateRFProfileGroup = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${RF_PROFILE_GROUP}`,
    method: 'PUT',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * delete RFProfileGroup.
 * @returns {Promise} - A promise that resolves with the update of Profile Group or rejects with an error.
 * @param data
 */
export const deleteRFProfileGroup = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${RF_PROFILE_GROUP}/${doubleEncode(data?.TenantId)}?tenant_id=${data?.TenantId}&profileID=${data?.SRFProfileGroupId}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * get RFProfileGroup.
 * @returns {Promise} - A promise that resolves with the RFProfileGroup or rejects with an error.
 * @param data
 */
export const getRFProfileGroup = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${RF_PROFILE_GROUP}/${data?.SRFProfileGroupId}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};

